var exports = {
  "N": "ProfileCardFooter.module__footerSection___MGpfTH",
};

module.exports = exports;
